<div class="pill__container">
  <div class="pill pill--{{ type }}">
    <span>
      <ng-content></ng-content>
    </span>
  </div>
</div>
